<template>   
<div> 
    <div class="form-group">
        <label for="email">{{labels.enterEmail}}</label>
        <input type="text" id="email" class="form-control" v-bind:class="{'error': inEmailAddressError}" aria-required="true" v-model="emailAddress" @blur="onEmailAddressBlur">
        <p v-if="inEmailAddressError" class="mt-2 errorMsg" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.emailAddressInvalid}}</p>
    </div>
     <div class="form-group" v-if="updateEmailPhoneTwice">
        <label for="confirmemail">{{labels.confirmEmail}}</label>
        <input type="text" id="confirmemail" class="form-control" v-bind:class="{'error': inConfirmEmailAddressError}" aria-required="true" v-model="confirmEmailAddress" @blur="onConfirmEmailAddressBlur">
        <p v-if="inConfirmEmailAddressError" class="mt-2 errorMsg" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{labels.emailAddressNotMatched}}</p>
    </div>
</div>
</template>

<script>
    export default {
        name: "MultiFactorEmailAddress",

        emits: ['set-email-address'],

        props: {
            labels: Object
        },

        data: function() {
            return {
                emailAddress: "",
                confirmEmailAddress: "",
                inEmailAddressError: null,
                inConfirmEmailAddressError: null,
                updateEmailPhoneTwice: RESOURSE_PROPERTIES.updateEmailPhoneTwice,
            }
        },

        methods: {
            isEmailAddressValid: function() {
                var valid;
                var atIndex = this.emailAddress.indexOf('@');
                var periodIndex = this.emailAddress.lastIndexOf('.');
                valid = atIndex >= 1 && atIndex <= (periodIndex - 2);
                return valid && periodIndex < this.emailAddress.length - 2;
            },
            isConfirmEmailAddressValid: function() {
                return this.confirmEmailAddress === this.emailAddress && this.confirmEmailAddress !== "";
            },
            onEmailAddressBlur: function() {
                this.setInEmailAddressError();
                if(this.updateEmailPhoneTwice && this.confirmEmailAddress != "")
                    this.setInConfirmEmailAddressError();
            },
            onConfirmEmailAddressBlur: function() {
                this.setInConfirmEmailAddressError();
            },
            setInEmailAddressError: function(){
                this.inEmailAddressError = !(this.isEmailAddressValid());
                return !this.inEmailAddressError;
            },
            setInConfirmEmailAddressError: function() {
                this.inConfirmEmailAddressError = !(this.isConfirmEmailAddressValid());
                return !this.inConfirmEmailAddressError;
            },
            validateAndEmitEmailAddress: function () {
                this.emitEmailAddress(this.isEmailAddressValid() && (this.updateEmailPhoneTwice ? this.isConfirmEmailAddressValid() : true) ? this.emailAddress : "");
            },
            emitEmailAddress: function(val){
                this.$emit('set-email-address', val)
            }
        },

        watch: {
            emailAddress: function() {
                this.inEmailAddressError = false;
                if(this.updateEmailPhoneTwice)
                    this.inConfirmEmailAddressError = false;
                this.validateAndEmitEmailAddress(); 
            },
            confirmEmailAddress: function(){
                this.inConfirmEmailAddressError = false;
                this.validateAndEmitEmailAddress();
            }
        }
    }
</script>